import { render, staticRenderFns } from "./Fideicomisos.vue?vue&type=template&id=3a1f35b0&scoped=true"
import script from "./Fideicomisos.vue?vue&type=script&lang=js"
export * from "./Fideicomisos.vue?vue&type=script&lang=js"
import style0 from "./Fideicomisos.vue?vue&type=style&index=0&id=3a1f35b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1f35b0",
  null
  
)

export default component.exports